const { select, dispatch } = wp.data;
const { count } = wp.wordcount;
const { serialize } = wp.blocks;
const { registerPlugin, unregisterPlugin } = wp.plugins;
const { PluginDocumentSettingPanel } = wp.editPost;

const PluginDocumentSettingPanelDemo = () => {

    let lockPost = false;

    // Word count
    const blocks = select( 'core/block-editor' ).getBlocks();
    const wordCount = count( serialize( blocks ), 'words' );
    let wordCountMessage = `${wordCount}`;
    if ( wordCount < 500 ) {
        lockPost = true;
    }

    // Links count
    const linkCount = serialize(blocks).split('<a').length -1;
    let linkCountMessage = `${linkCount}`;
    if ( linkCount < 1 ) {
        lockPost = true;
    }

    // Category set
    const cats = acf.getField('field_5e4a648f306b8').val();
    let catsMessage = 'Ingesteld';
    if ( cats == null ) {
        lockPost = true;
        catsMessage = 'Selecteer een categorie';
    }

    // Featured image set
    const featuredImageID = select( 'core/editor' ).getEditedPostAttribute( 'featured_media' );
    let featuredImage = 'Ingesteld';
    if ( featuredImageID === 0 ) {
        lockPost = true;
        featuredImage = 'Nog in te stellen';
    }

    // Check if we need to lock
    if ( lockPost === true ) {
        dispatch( 'core/editor' ).lockPostSaving();
    } else {
        dispatch( 'core/editor' ).unlockPostSaving();
    }

    return (<PluginDocumentSettingPanel
        name="custom-panel"
        className={'post-checklist'}
    >
        <p><b>Aantal woorden:</b> {wordCountMessage} {wordcountmessage(wordCount)}</p>
        <p><b>Categorie:</b> {catsMessage}</p>
        <p><b>Uitgelichte afbeelding:</b> {featuredImage}</p>
        <p><b>Links:</b> {linkCountMessage} {linkcountmessage(linkCount)}</p>
        {styles(wordCount, linkCount, featuredImageID, cats)}
    </PluginDocumentSettingPanel>)
};

registerPlugin('plugin-document-setting-panel-demo', {
    render: PluginDocumentSettingPanelDemo
});

function wordcountmessage(wordcount) {
    if (wordcount < 500) {
        return <span><br/><small>Minimaal 500 woorden nodig</small></span>;
    } else {
        return <span><br/><small>Je hebt het minimum van 500 woorden bereikt</small></span>;
    }
}

function linkcountmessage(linkcount) {
    if (linkcount < 2) {
        return <span><br/><small>Minimaal 2 links nodig</small></span>;
    } else {
        return <span><br/><small>Je hebt het minimum van 2 links bereikt</small></span>;
    }
}

function styles(wordCount, linkCount, featuredImageID, cats) {
    if (wordCount < 500 || linkCount < 2 || featuredImageID === 0 || cats == null) {
        return <style>{"\
        .post-checklist{\
          background:#ffd2c7;\
        }\
        [data-label='Document']:before{\
          background:#ffd2c7;\
          content:'!'!important;\
          background-color:#f3a6a6;\
          color:#a71010;\
          border-radius:50px;\
          width:20px;\
          height:20px;\
          display:inline-flex;\
          align-items:center;\
          justify-content:center;\
          margin-right:5px;\
          border-bottom:0px!important;\
          position:unset!important;\
        }\
        .edit-post-header__settings:after{\
          content: 'Let op: De post checklist is niet voltooid. Bekijk de checklist!';\
          border-radius: 3px;\
          padding: 7px 10px;\
          color: #ac1111;\
          border: 2px solid #ac1111;\
          background-color: #ffddd5;\
          position: absolute;\
          top: 10px;\
          right: 30%;\
          left: 30%;\
          text-align: center;\
        }\
      "}</style>
    } else {
        return <style>{"\
        .post-checklist{\
          background:#a2e7a2;\
        }\
      "}</style>
    }
}

function reRegisterPlugin() {
    unregisterPlugin('plugin-document-setting-panel-demo');
    registerPlugin('plugin-document-setting-panel-demo', {
        render: PluginDocumentSettingPanelDemo
    });

    setTimeout(reRegisterPlugin, 30000);
}

reRegisterPlugin();